import { UploadTypeModalComponent } from '../../../../screens/upload-type-modal/upload-type-modal.component';
import { OnboardingWalletModalComponent } from '../../../../screens/wallet-passes/onboarding-wallet-modal/onboarding-wallet-modal.component';
import { IdCardsComponent } from '../../../../../routes/id-cards/id-cards.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { DashboardNavComponent } from '../myinsurance-nav/dashboard-nav.component';
import { AllHeaderComponent } from '../myinsurance-headers/all-header/all-header.component';
import { HomeHeaderComponent } from '../myinsurance-headers/home-header/home-header.component';
import { CarHeaderComponent } from '../myinsurance-headers/car-header/car-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { DocumentsDataService } from './../../../../../_services/data-services/documents-data.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { PolicyDetailsService } from './../../../../../_services/my-insurance/policy-details.service';
import { UserService } from '../../../../../_services/user.service';
import { WalletCardService } from '../../../../../_services/_iam/wallet-card.service';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { FlagDataService } from '../../../../../_services/data-services/flag-data.service';
import { FlagResponse } from '@models/flag-response';
import { Capacitor } from '@capacitor/core';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { IdCardService } from '@services/id-card.service';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';
import { SortByDatePipe } from '@helpers/_pipes/sort-by-date.pipe';
import { SortPipe } from '@helpers/_pipes/sort.pipe';
import { PolicyBillingUploadService } from '@services/policy-billing-upload.service';
import { SearchPipe } from '@helpers/_pipes/search-pipe.pipe';
import { UrlValidationService } from '@services/document/url-validation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbDropdownModule, MapfreLoadingComponent, MapfreCardComponent, CarHeaderComponent, HomeHeaderComponent, AllHeaderComponent, DashboardNavComponent, MapfreButtonComponent, IdCardsComponent, OnboardingWalletModalComponent, UploadTypeModalComponent],
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  providers:[SortByDatePipe, SortPipe, SearchPipe]
})
export class DocumentDetailsComponent implements OnInit, OnDestroy {
  /*
   * Next few lines are for pagenation please do not remove them at this time
   * @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
   */

  firstItemIndex;
  lastItemIndex;

  documents: any = [];
  filterType = '';
  sortType: string;
  filterName = 'All documents';
  loading = false;
  policyId: string;
  policyDetails: any = [];
  activePolicies: any = [];
  previous: any = [];
  showNoDocuments = false;
  user: any;
  documentsData: any = [];
  initialDocumentsData: any = [];
  loadingDocuments: boolean;
  isAvailable: boolean;
  isAcmic: boolean;
  blob: Blob;
  filterBy: string;
  showUpArrowIcon: boolean;
  upArrowForDocName: string;
  upArrowForDate: string;
  downArrowForDocName: string;
  downArrowForDate: string;
  filterUpAndDownIcon: string;
  company: any;
  isEligibleForUpload: boolean;
  policy: any;
  upArrowForDName: boolean;
  upArrowForDDate: boolean;
  upAndDownIconForDocName: string;
  upAndDownIconForDocDate: string;
  docActionClass: string;
  // toggleUpDownArrosForSort: 
  /**
   *
   *  Information ----
   *  Many of these elements in here will become it's own component
   *  However I don't have the time at the moment to create a stand a lone version.
   *
   */

  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private userService: UserService,
    private walletCardService: WalletCardService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private documentsDataService: DocumentsDataService,
    private paperlessService: PaperlessService,
    private alertService: AlertService,
    private router: Router,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private errorRedirectionService: ErrorRedirectionService,
    private idCardService: IdCardService,
    private companyTypeService: CompanyTypeService,
    private sortByDatePipe: SortByDatePipe,
    private sortPipe: SortPipe,
    private searchPipe: SearchPipe,
    private pbUploadService: PolicyBillingUploadService,
    private elementRef: ElementRef,
    private urlValidationService: UrlValidationService
  ) {
    this.showUpArrowIcon = false;
    this.filterUpAndDownIcon = 'assets/img/images/icon-simple-arrow-down.svg';
    this.upAndDownIconForDocName = 'assets/img/images/icon-simple-arrow-down-black.svg';
    this.upAndDownIconForDocDate = 'assets/img/images/icon-simple-arrow-down-black.svg';
    this.sortType = '';
    this.isEligibleForUpload = false;
    this.upArrowForDName = false;
    this.upArrowForDDate = false;
  }

  onDownloadDocument(
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    index
  ) {
    this.docActionClass = 'download-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass)
    
    this.documentsDataService.getPolicyDocumentData(policyId,
      documentId,
      `${documentType}_${policyId}_${date}`,
      true,
      index
    );
  }

  onErrorResponse(err, policyId, description, indexToHideLoader) {
    this.documentsDataService.setCustomLoaderFlag(indexToHideLoader);
    if (err && err.error && err.error.Code === '965') {
      err.error.Message = err.error.Message.replace(
        'DOC_NAME',
        description
      );
    }
    this.errorRedirectionService.errorRedirectHandler(err, policyId);
  }
  
  onSuccessResponseForPresigned(indexToHideLoader, response, windowRef) {
    this.documentsDataService.setCustomLoaderFlag(indexToHideLoader);
    if (response) {
      if ( this.urlValidationService.isApprovedRedirectUrl(response?.presignedUrl)) {
      if (this.documentsDataService.isItIosDevice()) {
        if (!this.documentsDataService.handlePopupBlocker(windowRef)) {
          windowRef.location = response?.presignedUrl;
        }
      } else {
        const windowNonIos = window.open(response?.presignedUrl, '_blank');
        this.documentsDataService.handlePopupBlocker(windowNonIos);
      }
    }
  }
  }

  onViewDocument(
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    description: string,
    index
  ) {
    this.docActionClass = 'view-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass);
    if (Capacitor.isNativePlatform()) {
      this.documentsDataService.getPolicyDocumentData(policyId,
        documentId,
        `${documentType}_${policyId}_${date}`,
        false
      );
    } else {
      let windowRef;
      if (this.documentsDataService.isItIosDevice()) {
        windowRef = window.open();
      }
      this.policyDetailsService.getDocumentById(documentId,policyId).subscribe(
        (response) => {
            if(response) {
            this.onSuccessResponseForPresigned(index, response, windowRef);
          }          
        },
        (err) => {
          this.onErrorResponse(err, policyId, description, index);          
        }
      );
    }
  }

  onSelectFilter(filterName): void {
    switch (filterName) {
      case 'all-doc':
        this.filterType = '';
        this.filterName = 'All documents';
        this.applyFilter(this.initialDocumentsData);
        break;
      case 'end':
        this.filterType = 'ENDORSE';
        this.filterName = 'Filtered By: Endorsements';
        this.applyFilter(this.initialDocumentsData);
        break;
      case 'pol':
        this.filterType = 'PC';
        this.filterName = 'Filtered By: Policy';
        this.applyFilter(this.initialDocumentsData);
        break;
      case 'bill':
        this.filterType = 'BC';
        this.filterName = 'Filtered By: Billing';
        this.applyFilter(this.initialDocumentsData);
        break;
      case 'renew':
        this.filterType = 'RENEWAL';
        this.filterName = 'Filtered By: Renewal';
        this.applyFilter(this.initialDocumentsData);
        break;
    }
  }

  /*
   * Next few methods are for the pagenation for the data tables
   * At this moment of time we are not using them but please do not remove them
   */
  onNextPageClick(data) {
    this.firstItemIndex = data.first;
    this.lastItemIndex = data.last;
  }

  onPreviousPageClick(data) {
    this.firstItemIndex = data.first;
    this.lastItemIndex = data.last;
  }
  toggleUpDownIcon() {
    this.showUpArrowIcon = !this.showUpArrowIcon;
    if (this.showUpArrowIcon) {
      this.filterUpAndDownIcon = 'assets/img/images/icon-simple-arrow-up.svg';
    } else {
      this.filterUpAndDownIcon = 'assets/img/images/icon-simple-arrow-down.svg';
    }
  }
  defaultIconsForName() {
    this.upArrowForDocName = 'assets/img/images/icon-simple-arrow-up.svg';
    this.downArrowForDocName = 'assets/img/images/icon-simple-arrow-down.svg';
  }
  defaultIconsForDate() {
    this.upArrowForDate = 'assets/img/images/icon-simple-arrow-up.svg';
    this.downArrowForDate = 'assets/img/images/icon-simple-arrow-down.svg';
  }
  setUpDownArrowForDocName() {
    this.upArrowForDocName = 'assets/img/images/icon-simple-arrow-up-white.svg';
    this.downArrowForDocName = 'assets/img/images/icon-simple-arrow-down-white.svg';
  }
  setUpDownArrowForDate() {
    this.upArrowForDate = 'assets/img/images/icon-simple-arrow-up-white.svg';
    this.downArrowForDate = 'assets/img/images/icon-simple-arrow-down-white.svg';
  }
  

  sortDocumentsByName(order) {
    this.setUpDownArrowForDocName();
    this.defaultIconsForDate();
    this.sortType = 'doc-name';
    this.documentsData = this.sortPipe.transform(this.documentsData, 'description', order);
  }
  sortDocumentsByDate(order) {
    let transaction = 'transactionDate'
    if(order === 'dsc') {
      transaction = '-transactionDate'
    }
    this.setUpDownArrowForDate();
    this.defaultIconsForName();
    this.sortType = 'date';
    this.documentsData = this.sortByDatePipe.transform(this.documentsData, transaction);
  }
  
  toggleAndsortDocumentsByName() {
    this.upArrowForDName = !this.upArrowForDName;
    if (this.upArrowForDName) {
      this.upAndDownIconForDocName = 'assets/img/images/icon-simple-arrow-up-24.svg';
      this.documentsData = !this.isEligibleForUpload && !this.isAcmic ? this.sortPipe.transform(this.documentsData, 'description', 'asc') : this.sortPipe.transform(this.documentsData, 'fileName', 'asc');
    } else {
      this.upAndDownIconForDocName = 'assets/img/images/icon-simple-arrow-down-black.svg';
      this.documentsData = !this.isEligibleForUpload && !this.isAcmic ? this.sortPipe.transform(this.documentsData, 'description', '') : this.sortPipe.transform(this.documentsData, 'fileName', '');
    }
  }
  toggleAndsortDocumentsByDate() {
    this.upArrowForDDate = !this.upArrowForDDate;
    if (this.upArrowForDDate) {
      this.upAndDownIconForDocDate = 'assets/img/images/icon-simple-arrow-up-24.svg';
      this.documentsData = this.sortByDatePipe.transform(this.documentsData, 'transactionDate');
    } else {
      this.upAndDownIconForDocDate = 'assets/img/images/icon-simple-arrow-down-black.svg';
      this.documentsData = this.sortByDatePipe.transform(this.documentsData, '-transactionDate');
    }
    
  }
  
  getPolicyByPolicyNumber(policyList, policyId) {
    return policyList.find(policy => policy?.policynumber?.policyNumber === policyId);
  }

  applyFilter(policyDocuments) {
    const docs = this.searchPipe.transform(policyDocuments, 'type,source', this.filterType);
    this.documentsData = this.sortByDatePipe.transform(docs, '-transactionDate');
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
    this.loadingDocuments = true;
    this.defaultIconsForName();
    this.defaultIconsForDate();

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      this.isAvailable = response.doc;
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.filterBy = params['filter'];
      if (this.filterBy === 'pol') {
        this.onSelectFilter('pol');
      }
    });
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.documentsDataService.$renewalPoliciesDocumentData.subscribe(
        (policiesWithDocs) => {
          if (policiesWithDocs && policiesWithDocs.length>0) {
            const policyDocuments = policiesWithDocs.find(
              (element) => element.policyNumber == this.policyId
            );
            if (policyDocuments) {
              this.initialDocumentsData = [...policyDocuments];
              this.applyFilter(policyDocuments);
              this.loadingDocuments = false;
            }
          }
          if (this.documentsData.length == 0) {
            this.policyDetailsService
              .getDocumentsByPolicy(this.policyId)
              .subscribe(
                (documentResponse) => {
                  this.initialDocumentsData = [...documentResponse];
                  this.applyFilter(documentResponse);
                  this.loadingDocuments = false;
                },
                (err) => {
                  this.loadingDocuments = false;
                  this.errorRedirectionService.errorRedirectHandler(
                    err,
                    this.policyId
                  );
                }
              );
          }
        }
      );

      this.userService.$user.subscribe((user) => {
        this.user = user;
      });

      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policyDetails = policyResponse;
          this.policy = this.getPolicyByPolicyNumber(this.policyDetails, this.policyId);
          this.isEligibleForUpload = this.pbUploadService.isMAGWPolicy(this.policy);
          this.activePolicies = this.policyDataService.getActiveAutoPolicies(policyResponse);
          this.loading = false;
        }
      });
    });
    this.company = this.companyTypeService.getCompany(this.policyId);
    this.documentsDataService.getCustomLoader().subscribe(indexToHideLoader => {
      if(indexToHideLoader !== '') {
        this.documentsDataService.removeCustomLoaderClass(indexToHideLoader, this.elementRef, this.docActionClass);
        this.docActionClass = '';
      }
    });
  }

  viewEBILL() {
    const email = this.storageServiceObservablesService.getUserFromStorage();
    this.paperlessService.viewEBILL(email).subscribe(
      (response) => {
        this.documentsDataService.kubraLoginRequest(response);
      },
      () => {
        this.alertService.error('PROBLEM_IN_REQUEST_PROCESSING');
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }
    );
  }
  setFilterIcon(isOpen: boolean) {
    this.showUpArrowIcon = isOpen;
    if (this.showUpArrowIcon) {
      this.filterUpAndDownIcon = 'assets/img/images/icon-simple-arrow-up.svg';
    } else {
      this.filterUpAndDownIcon = 'assets/img/images/icon-simple-arrow-down.svg';
    }
  }

  getIdCardDocument(vehicle, action, policy) {
    this.idCardService.getIdCard(policy, action, policy.policynumber.policyNumber, vehicle);
  }
  isMultiVehEligibleForIdCard(vehicle) {
    return vehicle ? vehicle.filter(veh => veh.vehicleType !== 'utility_trailer') : [];
  }
  ngOnDestroy() {
    this.documentsData = [];
  }
}
